import _ from 'lodash';
import React from 'react';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {SelectRoomTypeField} from 'components/Fields';
import {buildRoomTypeSelectizeOption} from 'components/Fields/SelectRoomTypeField';

import {headOption} from 'utils/common';
import {required} from 'utils/validators';

import {selectModal, MODALS as BASE_MODALS} from 'ducks/modals';

export const initialValues = state => {
  const modal = selectModal(state, BASE_MODALS.CREATE_BOOKING);

  const groupedRoomTypes = _.get(modal, 'data.roomTypes', []);

  let roomTypes = _.flatten(
    groupedRoomTypes.map(roomTypeGroup => roomTypeGroup.roomTypes)
  );

  const selectedRoomType = headOption(roomTypes, buildRoomTypeSelectizeOption);

  return {
    roomType: selectedRoomType
  };
};

const RoomTypeSection = ({roomTypes, onRoomTypeChange}) => (
  <FormField>
    <Label>Room type</Label>
    <SelectRoomTypeField
      groupedRoomTypes={roomTypes}
      onChange={onRoomTypeChange}
      validate={[required]}
    />
  </FormField>
);

export default RoomTypeSection;
